import script from "./OidoAddressInput.vue?vue&type=script&setup=true&lang=js"
export * from "./OidoAddressInput.vue?vue&type=script&setup=true&lang=js"

import "./OidoAddressInput.vue?vue&type=style&index=0&id=57a522e0&scoped=true&lang=css"
import "./OidoAddressInput.vue?vue&type=style&index=1&id=57a522e0&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-57a522e0"]])

export default __exports__